/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { getMilestonesLifeEvents } from '../../store/milestones/actions';
import { GetMilestonesEventsNameSHByGUID } from '../../store/shipments/actions';
import {
    Row,
    Col,
    Container
} from "reactstrap";

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';


const MilestonesLifeEvent = ({ selectedRow }: any) => {
    const dispatch = useDispatch()
    const { milestoneBySelectedItem } = useSelector((state: any) => state.shipments);
    const { MilestonesLifeEvents } = useSelector((state: any) => state.Milestones);

    const [state, setState] = useState<any>({
        shipmentEvents: []
    })

    useEffect(() => {
        dispatch(getMilestonesLifeEvents())
        dispatch(GetMilestonesEventsNameSHByGUID({ GUID: selectedRow.GUID }))
    }, [])

    useEffect(() => {
        const newArray: any = [];
        milestoneBySelectedItem.map((item: any) => {
            newArray.push({ name: item.Name.toUpperCase() })
        })
        setState({ ...state, shipmentEvents: newArray })
    }, [milestoneBySelectedItem])

    return (
        <Container className="container">
            <div className="text-center mb-4">
                <h5>Milestones Tracking</h5>
            </div>
            {MilestonesLifeEvents.length !== 0 ?
                <Row>
                    <Col>
                        <div className="timeline-steps" >
                            {MilestonesLifeEvents.map((event: any, index: any) => {
                                return (
                                    <div className="timeline-step" key={index}>
                                        <div className="timeline-content">

                                            {!state.shipmentEvents.some((item: any) => item.name === event.name) ? (
                                                <div className="inner-circle"></div>
                                            ) :
                                                <div className="inner-circle2">
                                                    <div className="position-absolute"><i className='eventIconCheck bx bx-check' ></i></div>
                                                </div>
                                            }
                                            <p className="h6 text-muted mb-0 mb-lg-0">{event.name}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </Col>
                </Row> :
                <div className="text-center mb-4">
                    <i style={{ color: "red" }} className=' bx-flashing text-center d-flex justify-content-center eventIcon color-red bx bx-book-content' ></i>
                    <p>It needs to configure the Milestones in Milestones Life Events in order to see the order.</p>
                </div>
            }
        </Container>
    )
}

export default MilestonesLifeEvent